import { FC, memo, useCallback } from 'react';
import { isUndefined } from 'lodash-es';
import { ButtonGroup, ButtonProps, Group } from '@chakra-ui/react';

import { Button } from '~/core/middle-office/components';
import { ACTIVITY_CAUSER_OPTIONS } from './constants/activityCauser';
import { ActivityCauserButtonsProps } from './types/ActivityCauserButtonsProps';

const ActivityCauserFilterButtonsComponent: FC<ActivityCauserButtonsProps> = ({
  causerType: activeCauserType,
  onCauserChange,
}) => {
  const getFilterButtonStyles = useCallback(
    (isSelected: boolean): ButtonProps => {
      if (isSelected) {
        return {
          colorPalette: 'brandPrimary',
          fontWeight: 'bold',
          variant: 'solid',
        };
      }

      return {
        colorPalette: 'brandSecondary',
        fontWeight: 'normal',
        variant: 'outline',
      };
    },
    [],
  );

  return (
    <ButtonGroup size="md">
      <Group attached>
        <Button
          {...getFilterButtonStyles(isUndefined(activeCauserType))}
          onClick={() => onCauserChange(undefined)}
        >
          All
        </Button>
        {ACTIVITY_CAUSER_OPTIONS.map((causerType) => (
          <Button
            {...getFilterButtonStyles(causerType === activeCauserType)}
            key={causerType}
            onClick={() => onCauserChange(causerType)}
            textTransform="capitalize"
          >
            {causerType}
          </Button>
        ))}
      </Group>
    </ButtonGroup>
  );
};

export const ActivityCauserFilterButtons = memo(
  ActivityCauserFilterButtonsComponent,
);
